/**
 *
 * IeUxAlert
 *
 * UI for showing the alert inside IE "Website is best experienced in Chrome"
 */


const $ = require('jQuery');

var IeUxAlert = function (el) {
    this.$el = $(el);

    this.init();
};

IeUxAlert.prototype.init = function () {
    if (this.isIe()) {
        this.$el.removeClass('hide');
    }
};

IeUxAlert.prototype.isIe = function () {
    var ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
};

$(document).ready(function () {
    $('.js-ie-ux-alert').each(function () {
        new IeUxAlert(this);
    });
});
